import * as React from "react";
import { Field } from "formik";
import { TextAreaField } from "../../../components/DynamicForm/Elements/TextAreaField";
import { FormElementProps } from "./FormElementProps";

export const getTextAreaControl = (props: FormElementProps) => {
  return <Field component={TextAreaField} {...props} />;
};
